// Re-export items from stats for convenience, plus inventory management
import { ITEMS } from './stats.js';

export { ITEMS };

// Starting inventory
export const STARTING_INVENTORY = [
  { id: 'coffee_large', quantity: 2 },
  { id: 'antacid', quantity: 1 },
];
